import axios from "axios";
const API = process.env.REACT_APP_API_PATH;

export const fileUpload = async (description,gmtOffset,userLogId,originalFilename,formData) => {
    try {
  
      return await axios
        .post(`${API}/file/fileUpload`, formData, {
          headers: {
            'description':description,
            'gmtoffset':gmtOffset,
            'userlogid':userLogId,
            'originalfilename':originalFilename
          },
        })
        .then((res) => {
            console.log('fileUpload res:',res.data);
          return res;
        })
        .catch((err) => {
          return err.response;
        });
    } catch (err) {
        console.error(err);
      return err;
    }
  };

  
export const getProfilePic = async (profilePicId) => {
  try {

  const img= `${API}/file/image/${profilePicId}`;
  return img;

  } catch (err) {
    console.log('EEEEE',err)
    return err;
  }
};


// export const downloadFile = async (fileNo) => {
//   try {
//     console.log('downloadFile',fileNo);
//   const res= `${API}/file/download/${fileNo}`;
//   return res;

//   } catch (err) {
//     return err;
//   }
// };

export const downloadFile = async (fileNo,fileType) => {
  try {

    const response = await axios.get(`${API}/file/download/${fileNo}`, {
      responseType: 'blob',
    });

    // Create a temporary URL for the file
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a link element and click it programmatically to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileNo}${fileType}`);
    document.body.appendChild(link);
    link.click();

    // Clean up the temporary URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};



// function saveBase64ImageToFile(base64Image, filePath) {
//   console.log('saveBase64ImageToFile');
//   // Extract the base64 data from the image string
//   const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, '');

//   // Convert the base64 data to a buffer
//   const imageBuffer = Buffer.from(base64Data, 'base64');

//   // Write the buffer to the file
//   fs.writeFile(filePath, imageBuffer, (err) => {
//       if (err) {
//           console.error('Error saving the image:', err);
//       } else {
//           console.log('Image saved successfully:', filePath);
//       }
//   });
// }

function getFileTypeFromBase64(base64Image) {
  const matches = base64Image.match(/^data:(image\/[a-zA-Z+.-]+);base64,/);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null; // Invalid or unsupported data URI
}

function mimeTypeToExtension(mimeType) {
  const mimeMap = {
    'image/png': '.png',
    'image/jpeg': '.jpg',
    // Add more MIME types and extensions as needed
  };

  return mimeMap[mimeType] || '';
}

export const uploadBase64Image = async base64Image => {
  try {
    return new Promise(async (resolve, reject) => {
      // const base64Image = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAABlBMVEX///8AAABVwtN+AAAAC0lEQVR42mP8/wAAAQAB/6ZhWQAAAABJRU5ErkJggg==";
      const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, '');

      // Convert the Base64 data to a Blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      const fileSizeInBytes = byteCharacters.length;

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' });

      const mimeType = getFileTypeFromBase64(base64Image);
      const fileExtension = mimeTypeToExtension(mimeType);
      const originalFileName = `nnn${fileExtension}`;
      // Create a new FormData object and append the Blob
      const formData = new FormData();
      formData.append('file', blob, originalFileName); // 'file' is the field name

      const file = {
        name: originalFileName,
        size: fileSizeInBytes,
        type: fileExtension
      };
      const { name, size, type } = file;
      const fileDescription = `${name}, ${size}, ${type}`;
      fileUpload(fileDescription, '5:30', 1, originalFileName, formData)
        .then(res => {
          resolve({ res, file });
        })
        .catch(err => {
          reject(err);
        });
    });
  } catch (err) {
    console.error(err);
    return err;
  }
};
